import { dynamicApiSlice } from "../dynamicApi";
import { buildODataQuery } from "@/helpers";

interface Notification {
  workflowId: string;
  workflowName: string;
  variant: string;
  description: string;
  date: string;
}

export type NotificationList = Notification[];

export const notificationsApiSlice = dynamicApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<
      NotificationList,
      {
        filter?: string;
        select?: string[];
        expand?: string;
        top?: number;
        skip?: number;
      }
    >({
      query: (params) => `Notifications?${buildODataQuery(params)}`,
      transformResponse: (response: { value: NotificationList }) =>
        response.value,
    }),
    markAsRead: builder.mutation<void, string>({
      query: (notificationId) => ({
        url: `Notifications/${notificationId}`,
        method: "PUT",
      }),
      async onQueryStarted(notificationId, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            notificationsApiSlice.util.updateQueryData(
              "getNotifications",
              {},
              (draft) => {
                const index = draft.findIndex(
                  (notification) => notification.workflowId === notificationId
                );
                if (index !== -1) {
                  draft.splice(index, 1);
                }
              }
            )
          );
        } catch (error) {
          console.error("Error clearing notification:", error);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetNotificationsQuery, useMarkAsReadMutation } =
  notificationsApiSlice;
